import * as d3 from "d3";
import { useState, useEffect } from "react";

export const useData = (urls) => {
  const [censusData, setCensusData] = useState([]);
  // const [oldCensus, setOldCensus] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!loading) return;

    const promises = [d3.csv(urls["2021"]), d3.csv(urls["2011"])];

    Promise.all(promises).then((data) => {
      var retval = data[0].filter((d) => d.municipality);
      var oldCensus = data[1].filter((d) => d.spol === "sv.");

      retval.forEach((item) => {
        const oldData = oldCensus.filter(
          (d) => d.ime.toUpperCase() === item.municipality.toUpperCase()
        );

        if (oldData.length > 1) console.log("opaaa", oldData);

        if (oldData.length === 0) console.log("didnt find ", item.municipality);
        else {
          const newPopulation = +item.population;
          const oldPopulation = +oldData[0].ukupno;

          const change = (newPopulation - oldPopulation) / oldPopulation;

          item.previousPopulation = oldPopulation;
          item.currentPopulation = newPopulation;
          item.populationChange = change;

          // console.log(item.municipality, change, newPopulation, oldPopulation);
        }
      });

      setCensusData(retval);
      setLoading(false);
    });

    return () => undefined;
  });

  return {
    censusData,
    // oldCensus,
    loading,
  };
};
